import React from "react";
import {Grid} from "@mui/material";

const CustomMessage = props => {

    return (
        <Grid item xs={12} style={{padding: 16, display: "flex", justifyContent: "center", alignItems: "center", height: "calc(100vh - 201px)"}}>
            <img src={props.data} width="85%" alt="custom-image"/>
        </Grid>
    )
}

export default CustomMessage;